import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type PageIntroProps = {
  title: string;
  /** One or two sentences: what this page is for and what to do first. */
  description: string;
  className?: string;
  /** Optional right column (actions) — keeps full width layout */
  actions?: ReactNode;
};

/**
 * Consistent page title + guidance text (help article link is in the top bar).
 */
export function PageIntro({ title, description, className, actions }: PageIntroProps) {
  return (
    <div
      className={cn(
        'mb-6 flex w-full max-w-5xl flex-col gap-3 sm:mb-8 sm:flex-row sm:items-start sm:justify-between',
        className
      )}
    >
      <div className="min-w-0 flex-1 space-y-2">
        <h1 className="text-2xl font-bold tracking-tight text-foreground">{title}</h1>
        <p className="text-sm leading-relaxed text-muted">{description}</p>
      </div>
      {actions ? <div className="flex shrink-0 flex-wrap gap-2">{actions}</div> : null}
    </div>
  );
}
